/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// SET STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    storytitle: {
        position: 'relative',
        zIndex: 2,
        '& .titletext':{
            fontSize: pxToEm(26),
            fontFamily: 'Verdana',
            fontWeight: 'bold',
            textDecoration: 'underline',
            lineHeight: pxToEm(18),
            width: '98%',
            height: 'fit-content',
            marginBottom: pxToEm(7),
            wordBreak: 'break-word',
            '&:hover':{
                cursor: 'pointer',
                textDecoration: 'underline'
            }
        },
        //animation
        opacity: '0',
        animationName: 'fadeInRight',
        animationDelay: '.1s',
        animationDuration: '.2s',
        animationFillMode: 'forwards'
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.medium]: {
        storytitle: {
            '& .titletext': {
                fontSize: pxToEm(30),
                width: '95%',
                textDecoration: 'none',
                '& :hover':{
                    textDecoration: 'underline'
                }
            }
        }
    },
    [mediaQuery.wide]: {
        storytitle: {
            '& .titletext': {
                textDecoration: 'none',
                width: '95%',
                '& :hover':{
                    textDecoration: 'underline'
                }
            }
        }
    }
};